import { Event, Media, User, Group, Post, IEvent, IGroup, IUser, IMedia, IPost, IConversation, Conversation, ConversationMessage, IConversationMessage, IArticle, Article, IPlace, Place, ISentiment, Sentiment, IPage, Page } from '@/classes'
import { IOrganization, Organization } from './Organization'

export type StoreItems = Ref<Map<string, any>>
export type StoreItemTypes = Event | Media | User | Post

export type StoreInterfaces = {
  'event': IEvent,
  'user': IUser,
  'media': IMedia,
  'post': IPost,
  'group': IGroup,
  'conversation': IConversation,
  'conversation-message': IConversationMessage,
  'article': IArticle,
  'place': IPlace,
  'sentiment': ISentiment,
  'page': IPage,
  'organization': IOrganization
}

export interface StoreTypeMap {
  'event': Event,
  'user': User,
  'media': Media,
  'post': Post,
  'group': Group,
  'conversation': Conversation,
  'conversation-message': ConversationMessage,
  'article': Article,
  'place': Place,
  'sentiment': Sentiment,
  'page': Page,
  'organization': Organization
}

export const StoreTypeMapValues = {
  event: Event,
  user: User,
  media: Media,
  post: Post,
  group: Group,
  conversation: Conversation,
  'conversation-message': ConversationMessage,
  article: Article,
  place: Place,
  sentiment: Sentiment,
  page: Page,
  organization: Organization
}